import { render, staticRenderFns } from "./TechConsulting.vue?vue&type=template&id=004124b6&scoped=true&"
import script from "./TechConsulting.vue?vue&type=script&lang=js&"
export * from "./TechConsulting.vue?vue&type=script&lang=js&"
import style0 from "./TechConsulting.vue?vue&type=style&index=0&id=004124b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004124b6",
  null
  
)

export default component.exports